import React, { useEffect, useRef, useState } from 'react';
import apiUrl from '@common/utils/apiURL';
import useApi from '@common/utils/useApi';
import { Link } from 'react-router-dom'
import ProfileMenu from '@common/components/ProfileMenu';
import OrderCard from './components/OrderCard';


function MyOrders() {
    const [orderData, setOrdereData] = useState([]);
    const getOrderURL = apiUrl.orderDetails.getOrderDetails;
    
    const { data: responseOrderData, loading: isLoadingOrderData, errorOrderData } = useApi(getOrderURL);
    // console.log("sagar", responseOrderData, orderData?.data?.order)
    useEffect(() => {
        // console.log('responseAllTimeFav', isLoadingAllTimeFav, responseAllTimeFav, cartData);
        if (!isLoadingOrderData && responseOrderData) {
            setOrdereData(responseOrderData?.data?.order.sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate)));
        }
    }, [isLoadingOrderData, responseOrderData]);

    const getProfileURL = apiUrl.profile.getProfile;
    const { data: responseProfileData, loading: isLoadingProfileData, errorProfileData } = useApi(getProfileURL);
    useEffect(() => {
        // console.log('responseAllTimeFav', isLoadingAllTimeFav, responseAllTimeFav, cartData);
        if (!isLoadingProfileData && responseProfileData) {
            localStorage.setItem('u_info', JSON.stringify(responseProfileData?.data));
        }
    }, [isLoadingProfileData, responseProfileData]);


  return (
    <div className='bs-section'>
        <div className='lyt-profile'>
            <div className='lyt-profile__header'>
                <Link className='lyt-profile__title'>
                    <span className='icon icon-o-left lyt-profile__title-icon'></span>
                    <span className='lyt-profile__title-text'>your profile</span>
                </Link>
            </div>
            <div className='lyt-profile__body'>
                <ProfileMenu data={JSON.parse(localStorage.getItem('u_info'))} />
                <div className='lyt-profile__cont-wrap'>
                    <div className='lyt-order'>
                        <div className='lyt-order__header'>
                            <h2 className='lyt-order__title'>my orders</h2>
                        </div>
                        <div className='lyt-order__body'>
                            <ul className='lyt-order__list'>
                            {orderData.map((item, index) => {
                                return(
                                <li className='lyt-order__list-item'>
                                    
                                <OrderCard status={item?.status} orderDetails={item}/>
                            </li>)
                            })}
                                {/* <li className='lyt-order__list-item'>
                                    <OrderCard status={'pending'} />
                                </li>
                                <li className='lyt-order__list-item'>
                                    <OrderCard status={'delivered'} />
                                </li>
                                <li className='lyt-order__list-item'>
                                    <OrderCard status={'cancelled'} />
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default MyOrders